import { ConsentsAndDeclarationsType } from '../../../api/types';
import CheckboxConsentsAndDeclarationsDetails, {
    type CheckboxConsentFormValues,
} from './CheckboxConsentsAndDeclarationsDetails';
import { type cndSettings } from './ConsentsAndDeclarationsInnerPage';
import MarketingConsentsAndDeclarationsDetails from './MarketingConsentsAndDeclarationsDetails';
import TextConsentsAndDeclarationsDetails, { type TextConsentFormValues } from './TextConsentsAndDeclarationsDetails';

export type ConsentsAndDeclarationsDetailsProps = {
    initialValues: cndSettings;
    updated?: string;
    type?: ConsentsAndDeclarationsType;
    moduleName?: string;
    offset?: string;
    disabled?: boolean;
};

const ConsentsAndDeclarationsDetails = ({
    initialValues,
    updated,
    type,
    moduleName,
    offset,
    disabled = false,
}: ConsentsAndDeclarationsDetailsProps) => {
    switch (type) {
        case ConsentsAndDeclarationsType.Checkbox: {
            const checkboxConsentInitialValues = initialValues as CheckboxConsentFormValues;

            return (
                <CheckboxConsentsAndDeclarationsDetails
                    disabled={disabled}
                    initialValues={checkboxConsentInitialValues}
                    moduleName={moduleName}
                    offset={offset}
                    updated={updated}
                />
            );
        }

        case ConsentsAndDeclarationsType.Marketing: {
            return (
                <MarketingConsentsAndDeclarationsDetails
                    disabled={disabled}
                    moduleName={moduleName}
                    offset={offset}
                    updated={updated}
                />
            );
        }

        case ConsentsAndDeclarationsType.Text:
        default: {
            const textConsentInitialValues = initialValues as TextConsentFormValues;

            return (
                <TextConsentsAndDeclarationsDetails
                    disabled={disabled}
                    initialValues={textConsentInitialValues}
                    moduleName={moduleName}
                    offset={offset}
                    updated={updated}
                />
            );
        }
    }
};

export default ConsentsAndDeclarationsDetails;
